import qs from 'qs';

/**
 * Returns a new querystring with specified additions.
 *
 * @param {String} queryString existing querystring
 * @param {Object} additions keys mapped to values to add
 */
export const addToQueryString = (queryString, additions) => {
  const queryStringObj = {
    ...qs.parse(queryString, { ignoreQueryPrefix: true }),
    ...additions,
  };

  return `?${qs.stringify(queryStringObj)}`;
};

/**
 * Returns a new querystring with the specified properties removed.
 *
 * @param {String} queryString
 * @param {Array<String>} namesToRemove list of names to remove
 */
export const removeFromQueryString = (queryString, namesToRemove) => {
  const queryStringObj = qs.parse(queryString, { ignoreQueryPrefix: true });
  namesToRemove.forEach((name) => {
    delete queryStringObj[name];
  });

  return `?${qs.stringify(queryStringObj)}`;
};



// WEBPACK FOOTER //
// ./src/common/Helpers/querystring.js